import { inject, Injectable } from '@angular/core';
import { CapacitorService, EnvironmentService } from '@libs/shared/common';
import { NavItemModel, URL_PARAMETER_UTM_CAMPAIGN, URL_PARAMETER_UTM_MEDIUM, URL_PARAMETER_UTM_SOURCE } from '@libs/shared/models';
import { PageInfoTrackingService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class NavigationTrackingService {
  private readonly pageInfoTracker: PageInfoTrackingService = inject(PageInfoTrackingService);
  private readonly capacitorService: CapacitorService = inject(CapacitorService);
  private readonly environmentService: EnvironmentService = inject(EnvironmentService);

  public trackItem(item: NavItemModel): void {
    const routeParts: string[] = [];

    let node: NavItemModel | undefined = item;

    while (node) {
      routeParts.push(String(node.label));
      node = node.parent;
    }

    const route: string = routeParts.reverse().join(' / ');

    this.pageInfoTracker.track(route);
  }

  public trackingLink(link: string, campaign: string): string {
    const url: URL = new URL(link);

    url.searchParams.set(URL_PARAMETER_UTM_SOURCE, this.environmentService.app().applicationId ?? 'unknown');
    url.searchParams.set(URL_PARAMETER_UTM_MEDIUM, this.capacitorService.getPlatform());
    url.searchParams.set(URL_PARAMETER_UTM_CAMPAIGN, campaign);

    return url.toString();
  }
}
